import { render, staticRenderFns } from "./productdetail-swiper.vue?vue&type=template&id=4db41b32&scoped=true&"
import script from "./productdetail-swiper.vue?vue&type=script&lang=js&"
export * from "./productdetail-swiper.vue?vue&type=script&lang=js&"
import style0 from "./productdetail-swiper.vue?vue&type=style&index=0&id=4db41b32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db41b32",
  null
  
)

export default component.exports